import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../store';
import { logout } from '../../store/slices/authSlice';

const { Title, Text } = Typography;

const MaintenancePage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((s) => s.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)',
        padding: '40px 24px',
        textAlign: 'center',
      }}
    >
      {/* Animated gear icon */}
      <div
        style={{
          width: 100,
          height: 100,
          borderRadius: '50%',
          background: 'rgba(22,119,255,0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 32,
          border: '2px solid rgba(22,119,255,0.3)',
          animation: 'spin 8s linear infinite',
        }}
      >
        <ToolOutlined style={{ fontSize: 48, color: '#60a5fa' }} />
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>

      {/* Badge */}
      <div
        style={{
          background: 'rgba(239,68,68,0.15)',
          border: '1px solid rgba(239,68,68,0.4)',
          borderRadius: 20,
          padding: '6px 20px',
          marginBottom: 24,
          display: 'inline-block',
        }}
      >
        <span style={{ color: '#f87171', fontWeight: 700, fontSize: 13, letterSpacing: 1 }}>
          🔴 UNDER MAINTENANCE
        </span>
      </div>

      <Title
        level={1}
        style={{
          color: '#f1f5f9',
          fontWeight: 900,
          fontSize: 'clamp(28px, 5vw, 48px)',
          margin: '0 0 16px',
          lineHeight: 1.2,
        }}
      >
        We'll be right back
      </Title>

      <Text
        style={{
          color: '#94a3b8',
          fontSize: 18,
          display: 'block',
          maxWidth: 480,
          lineHeight: 1.7,
          marginBottom: 12,
        }}
      >
        WorkWav is currently undergoing scheduled maintenance to bring you a better experience.
      </Text>

      <Text
        style={{
          color: '#64748b',
          fontSize: 15,
          display: 'block',
          marginBottom: 40,
        }}
      >
        Please check back shortly. We apologise for any inconvenience.
      </Text>

      {/* Actions */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
        {isAuthenticated ? (
          <Button
            size="large"
            onClick={handleLogout}
            style={{
              borderRadius: 10,
              fontWeight: 600,
              borderColor: 'rgba(255,255,255,0.2)',
              color: '#94a3b8',
              background: 'transparent',
            }}
          >
            Sign Out
          </Button>
        ) : (
          <Button
            type="primary"
            size="large"
            onClick={() => navigate('/login')}
            style={{ borderRadius: 10, fontWeight: 700 }}
          >
            Admin Login
          </Button>
        )}
      </div>

      {/* Footer note */}
      <Text style={{ color: '#334155', fontSize: 13, marginTop: 56 }}>
        WorkWav &copy; {new Date().getFullYear()} — Ride Your Career Wave
      </Text>
    </div>
  );
};

export default MaintenancePage;
